import { Reference } from '@apollo/client';
import * as graphql from 'generated/graphql';
import { dateTimeFieldPolicy } from './fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const Person: ITypeSpecificPolicy<graphql.Person> = {
  fields: {
    createdTimestamp: dateTimeFieldPolicy(),

    currentOrganization: {
      read: (existing, { readField }) => {
        const memberships = readField<Reference[]>('memberships');
        if (!memberships) {
          return existing;
        }

        const [first] = memberships;
        if (!first) {
          return existing;
        }

        const organization = readField<Reference>({
          fieldName: 'organization',
          from: first
        });

        if (!organization) {
          return existing;
        }

        return organization;
      }
    }
  }
};
